import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Leave this page?</h2>
    <mat-dialog-content>
      <p>You have unsaved changes. If you leave this page, you may lose your changes.</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button data-test="stay" (click)="dialogRef.close(false)">Stay on page</button>
      <button mat-raised-button color="warn" data-test="leave" (click)="dialogRef.close(true)">Leave page</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-actions {
      justify-content: flex-end;
      gap: 8px;
    }
  `]
})
export class UnsavedChangesDialogComponent {
  dialogRef = inject<MatDialogRef<UnsavedChangesDialogComponent, boolean>>(MatDialogRef);
}
